import {
  Color,
  ColorShades,
  Colors,
  ThemedColor,
  ThemedColorsMap,
  ThemedColors,
  ColorShadesKeys,
} from '../../types/Colors'

export const reverseColorShades = (shades: ColorShades): ColorShades => {
  const keys = Object.keys(shades).sort()
  const reversedKeys = [...keys].reverse()

  const reversedShades: Record<string, string> = {}
  keys.forEach((key, index) => {
    const reversedKey = reversedKeys[index]
    reversedShades[key] = shades[reversedKey]
  })

  return reversedShades as ColorShades
}

export const reverseColors = (colors: Colors) => {
  const reversedColors: Colors = {} as Colors

  ;(Object.keys(colors) as Color[]).forEach((color) => {
    const reversedShades = reverseColorShades(colors[color])
    reversedColors[color] = reversedShades
  })

  return reversedColors
}

export const createThemedColorShade = (color: Color): ColorShades => {
  const keys: ColorShadesKeys[] = [0, 50, 100, 200, 300, 400, 500, 600, 700, 800]
  const shades: ColorShades = {} as ColorShades

  keys.forEach((key) => {
    shades[key] = `var(--${color}-${key})`
  })

  return shades
}

export const createThemedColors = (themedColorsMap: ThemedColorsMap): ThemedColors => {
  const themedColors: ThemedColors = {} as ThemedColors

  ;(Object.keys(themedColorsMap) as ThemedColor[]).forEach((themedColor) => {
    const familyColor = themedColorsMap[themedColor]
    themedColors[themedColor] = createThemedColorShade(familyColor)
  })

  return themedColors
}
